import { useState } from 'react';
import { useSpring } from 'react-spring';

function useTextFadeSwitcher(text1 = "Default Text 1", text2 = "Default Text 2", interval = 5000, fontSize = "16px", lineHeight = "1", fontColor = "white") {
    const texts = [text1, text2];
    const [index, setIndex] = useState(0);
    const [isFadingOut, setIsFadingOut] = useState(false);

    const fadeProps = useSpring({
        opacity: isFadingOut ? 0 : 1,
        from: { opacity: isFadingOut ? 1 : 0 },
        config: { duration: interval / 2 },
        onRest: () => {
            if (isFadingOut) {
                setIndex((prevIndex) => (prevIndex + 1) % texts.length);
                setIsFadingOut(false);
            } else {
                setIsFadingOut(true);
            }
        },
        reset: true,
    });

    const textStyle = {
        fontSize, // Aggiungi la dimensione del font come stile
        lineHeight, // Imposta l'interlinea
        fontColor,

        // Altri stili del testo se necessario
    };

    return {
        text: texts[index],
        fadeProps,
        textStyle, // Aggiungi lo stile del testo alle props restituite
    };
}

export default useTextFadeSwitcher;
